export default function (_payload, models, verb = "edited") {
  let user = models.user || {}
  return {
    actor: `user-${user.id}`,
    verb: verb,
    object: `course-${models.course.id}`,
    to: [
      `course-edits:course-${models.course.id}`,
      `planbook-edits:planbook-${models.planbook.id}`,
    ],
  }
}
